module.exports = __webpack_public_path__ + "static/media/IC204amg.81f514ee.jpg";